import {IMembersFormatFilter} from '@hooks';
import {useMemo} from 'react';
import {useStoreContext} from '@store/store-context';
import {FeedbackController} from '../feedback-controller';
import {FeedbackRequestImpl} from '../feedback-requests';
import {useState} from 'react';
import {IOptions} from '../components/values-themes-filter';
import {useNavigate} from 'react-router';
import {toInclusiveFeedbackEndDate} from '../feedback-date.utils';
import {allTimeFeedbackRange} from '../feedback-date-range';

export const usePublicWallHook = () => {
  const [selectedPerson, setSelectedPerson] = useState('');
  const [sortBy, setSortBy] = useState('desc');
  const [userFilter, setUserFilter] = useState({
    filterBy: {
      label: 'People',
      value: 'people',
    },
    selectedTeam: {
      value: '',
      label: '',
    },
    members: [] as Array<IMembersFormatFilter>,
  });
  const {
    usersStore: {users},
  } = useStoreContext();

  const navigate = useNavigate();

  const handleWriteFeedback = () => {
    navigate('/write-feedback');
  };
  const handleRequestFeedback = () => {
    navigate('/request-feedback');
  };
  const handleWritePraise = () => {
    navigate('/write-feedback?type=praise');
  };

  const [valueThemeFilter, setValueThemeFilter] = useState<IOptions>({
    filterBy: '',
    theme: '',
    value: '',
  });

  const [dateRange, setDateRange] = useState(allTimeFeedbackRange);

  const request = useMemo(() => new FeedbackRequestImpl(), []);
  const controller = useMemo(() => new FeedbackController(request), [request]);

  const formatFilteredUser = useMemo(() => {
    const manager = userFilter.selectedTeam.value;
    if (userFilter.members?.length > 0) {
      return userFilter.members.map((member) => member.value).join(',');
    }

    if (manager) {
      return users
        .filter((user) => (user.reviewer?.id || user?.reviewer) === manager)
        .map((user) => user.id)
        .join(',');
    }
  }, [userFilter.selectedTeam.value, users, userFilter.members]);

  const filters = useMemo(() => {
    return {
      paginate: false,
      startDate: dateRange.starts || undefined,
      endDate: dateRange.ends
        ? toInclusiveFeedbackEndDate(dateRange.ends)
        : undefined,
      impression: valueThemeFilter.theme,
      values: valueThemeFilter.value,
      user: formatFilteredUser || undefined,
      isPraise: true,
      sortBy,
    };
  }, [
    dateRange.starts,
    formatFilteredUser,
    dateRange.ends,
    valueThemeFilter.theme,
    valueThemeFilter.value,
    sortBy,
  ]);

  return {
    userFilter,
    setUserFilter,
    controller,
    filters,
    dateRange,
    selectedPerson,
    setSelectedPerson,
    sortBy,
    setSortBy,
    handleWriteFeedback,
    handleRequestFeedback,
    handleWritePraise,
    setDateRange,
    valueThemeFilter,
    setValueThemeFilter,
  };
};
